import { createContext, ReactNode, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { User } from '@domain/user';
import { removePublicPageToken, setPublicPageToken } from '@utils/token/authTokens';
import { PUBLIC_PAGE_TOKEN } from '@utils/token/constants';

import { SHARED_REPORT_TOKEN_QUERY_PARAM, UserContextValue } from './user.type';

export const UserContext = createContext<UserContextValue>({
  userState: null,
  isUserLoading: true,
  setUserState: () => {},
  setIsUserLoading: () => {},
});

export const UserProvider = ({ children }: { children: ReactNode }) => {
  const [searchParams] = useSearchParams();
  const sharedReportToken = searchParams.get(SHARED_REPORT_TOKEN_QUERY_PARAM);
  const [userState, setUserState] = useState<User | null>(null);
  const [isUserLoading, setIsUserLoading] = useState<boolean>(!sharedReportToken);
  if (sharedReportToken) setPublicPageToken({ key: PUBLIC_PAGE_TOKEN, token: sharedReportToken });
  else removePublicPageToken({ key: PUBLIC_PAGE_TOKEN });
  return (
    <UserContext.Provider value={{ userState, setUserState, isUserLoading, setIsUserLoading }}>
      {children}
    </UserContext.Provider>
  );
};
